var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillingWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 22.5H26V16.5C26 16.1022 25.842 15.7206 25.5607 15.4393C25.2794 15.158 24.8978 15 24.5 15H15.5C15.1022 15 14.7206 15.158 14.4393 15.4393C14.158 15.7206 14 16.1022 14 16.5V22.5H13.5C13.3674 22.5 13.2402 22.5527 13.1464 22.6464C13.0527 22.7402 13 22.8674 13 23V24C13 24.3978 13.158 24.7794 13.4393 25.0607C13.7206 25.342 14.1022 25.5 14.5 25.5H25.5C25.8978 25.5 26.2794 25.342 26.5607 25.0607C26.842 24.7794 27 24.3978 27 24V23C27 22.8674 26.9473 22.7402 26.8536 22.6464C26.7598 22.5527 26.6326 22.5 26.5 22.5ZM15 16.5C15 16.3674 15.0527 16.2402 15.1464 16.1464C15.2402 16.0527 15.3674 16 15.5 16H24.5C24.6326 16 24.7598 16.0527 24.8536 16.1464C24.9473 16.2402 25 16.3674 25 16.5V22.5H15V16.5ZM26 24C26 24.1326 25.9473 24.2598 25.8536 24.3536C25.7598 24.4473 25.6326 24.5 25.5 24.5H14.5C14.3674 24.5 14.2402 24.4473 14.1464 24.3536C14.0527 24.2598 14 24.1326 14 24V23.5H26V24ZM21.5 17.5C21.5 17.6326 21.4473 17.7598 21.3536 17.8536C21.2598 17.9473 21.1326 18 21 18H19C18.8674 18 18.7402 17.9473 18.6464 17.8536C18.5527 17.7598 18.5 17.6326 18.5 17.5C18.5 17.3674 18.5527 17.2402 18.6464 17.1464C18.7402 17.0527 18.8674 17 19 17H21C21.1326 17 21.2598 17.0527 21.3536 17.1464C21.4473 17.2402 21.5 17.3674 21.5 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingWebsite);
export default __webpack_public_path__ + "static/media/billing-website.26cd2536aaf84e0ea424cf3d611edbf2.svg";
export { ForwardRef as ReactComponent };